import {MuWidget} from "mu-widget/lib/MuWidget";

export class CommonListItem extends MuWidget {
    // @ts-ignore
    click: string;
    item: any;

    container_click() {
        // @ts-ignore
        this.muParent[this.click](this.item);
    }

    protected muAfterBindData(data: any) {
        this.item = data;
    }
}